import { companyClient } from "api/api";
import type { IChecklistWithResponses } from "../types/checklists";

export const getAppointmentChecklists = async (
  appointmentId: number
): Promise<IChecklistWithResponses[]> => {
  const res = await companyClient({
    method: "GET",
    url: `/appointment-checklists/${appointmentId}`,
  });
  return Array.isArray(res.data) ? res.data : [];
};
